module.exports = __webpack_public_path__ + "assets/img/typeIcon-1-blue.6367594f.svg";